import React, { useEffect, useState, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { handlerFormError, formatDateString } from "../../Utils/Utils";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { profile, no_image } from "../../Images";
import { getAssets, getAssetById, setAccessUrl, setCounter, sharedUrl } from "../../Services/AssetService";
import { getUserIdentity, getUsers } from "../../Services/UserService";
import { createLog } from "../../Services/LogService";
import { createFavorite } from "../../Services/FavoriteService";
import { useSelector } from "react-redux";
import FileSaver from "file-saver";
//import VideoPlayer from 'react-video-js-player';
import Modal from "../../Components/Layout/Modal";
import Overlay from "../../Components/Overlay/Overlay";
// import ReactPlayer from 'react-player'
import parser from "html-react-parser";
import { truncate } from "../../Utils/Utils";

const { $ } = window;
const modalId = "#share-modal";
let processingId = -1;
let list = [];

const AssetDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { userInfo } = useSelector((state) => state.auth);
    const [isLoading, setIsLoading] = useState(false)
    const [videoState, setVideoState] = useState("");
    const [state, setState] = useState({
        asset: { _id: -1 },
        expires: ["30 Minute", "1 Hours", "8 Hours", "1 Day"],
        expire: 1800,
        assets: [],
        username: "",
        avatar: "",
        url: "",
        file_size: "",
        file_index: 0,
        processing: false,
        email: "",
        emails: [],
        isFocus: false,
        selectedLists: [],
    });

    const setToHtml = (param) => {
        return parser(param);
    };

    const setStates = (data) => {
        setState({ ...state, ...data });
    };

    const onAssetClick = (id) => () => {
        navigate("/asset/detail/" + id);
    };

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    };

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    };

    const onChangeExpire = (e) => {
        const { file_size, file_index } = state;
        let new_expire;
        switch (e.target.value) {
            case "1 Hours":
                new_expire = 3600;
                break;
            case "8 Hours":
                new_expire = 28800;
                break;
            case "1 Day":
                new_expire = 86400;
                break;
            default:
                new_expire = 1800;
                break;
        }
        setState({ ...state, expire: new_expire });
        setTimeout(() => {
            saveFile("shared", new_expire, file_size, file_index);
        }, 1000);
    };

    const onChangeEmail = (e) => {
        setState({ ...state, email: e.target.value, isFocus: true });
    };

    const setDateFormat = (param) => {
        let date = "";
        date = param === undefined ? "" : formatDateString(param);
        return date;
    };

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 3,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    const onBack = () => {
        navigate(-1);
    };

    const onCloseModal = () => {
        setState({
            ...state,
            isFocus: false,
            url: "",
            email: "",
            selectedLists: [],
        });
        list = [];
        $(modalId).modal("hide");
    };

    const onShareUrls = () => {
        const { expire } = state;
        let expire_time = "";
        switch (expire) {
            case 3600:
                expire_time = "1 Hour";
                break;
            case 28800:
                expire_time = "8 Hours";
                break;
            case 86400:
                expire_time = "1 Day";
                break;
            default:
                expire_time = "30 Minutes";
                break;
        }
        let content =
            "Hi!<br><br>you have received a shared file from " +
            userInfo.email +
            '<br>Please click link to open/download the file :<br><br><a href="' +
            url +
            '" _target="_blank">Click here</a><br><br>Kindly note that it will be expire in ' +
            expire_time +
            ".<br><br>Have a great day!<br><br>Regards,<br><b>MODENA Creative Asset Bank</b>";
        const data = {
            receipts: selectedLists,
            subject: "You have received a file from MODENA Creative Asset Bank",
            comment: content,
        };

        startProcessing();

        sharedUrl(data)
            .then((res) => {
                if (res.status == 200 || res.status == 201) {
                    Swal.fire({
                        icon: "success",
                        title: "Shared URL success",
                        text: "Data has been mailed!",
                    }).then((r) => {
                        setState({
                            ...state,
                            isFocus: false,
                            url: "",
                            email: "",
                            selectedLists: [],
                        });
                        list = [];
                        $(modalId).modal("hide");
                    });
                }
            })
            .catch(({ response: { data } }) => {
                handlerFormError(data.message);
            })
            .finally((_) => stopProcessing());
    };

    const updateLogs = (id, status) => {
        const body = {
            id: id,
            log_type: status,
            userid: userInfo.userid,
        };

        createLog(
            body,
            (res) => {
                // if (res.status == 200 || res.status == 201) {
                //     console.log('success insert log')
                // }
            },
            (error) => {
                console.log("error insert log");
            }
        );
    };

    const onSelectEmail = (item) => {
        const ada = list.find((e) => e.email == item.email);
        if (ada === undefined) {
            list.push({ name: item.employe_name, email: item.email });
            setState({ ...state, isFocus: false, selectedLists: list, email: "" });
        } else {
            setState({ ...state, isFocus: false });
        }
    };

    const removeEmailList = (item) => {
        list.splice(
            list.findIndex((e) => e.email === item),
            1
        );
        setState({ ...state, isFocus: false, selectedLists: list });
    };

    const showModal = (param = "std", index = 0) => {
        setState({ ...state, file_size: param, file_index: index });
        setTimeout(() => {
            $(modalId).modal("show");
        }, 300);
    };

    const saveFile = (type, expire = 1800, param = "std", index = 0, passet = null) => {
        // FileSaver.saveAs("https://httpbin.org/image", "image.jpg");
        const { asset } = state;

        let file = passet === null ? asset?.file[param] : passet?.file[param];

        if (file.access === "FULL_CONTROL,READ") {
            if (type === "favorite") {
                // FileSaver.saveAs(file.object_url, file.preview_url.split("/").pop());
                downloadFile(file.object_url, file.preview_url.split("/").pop());
            } else if (type === "shared") {
                setState({ ...state, url: file.object_url });
            } else {
                setVideoState(file.object_url);
            }
        } else {
            const body = {
                file: param,
                index: index,
                expired: expire,
            };

            setAccessUrl(
                id,
                body,
                (res) => {
                    if (res.status == 200 || res.status == 201) {
                        if (type === "favorite") {
                            // FileSaver.saveAs(res.data.fileUrl, res.data.fileName);
                            downloadFile(res.data.fileUrl, res.data.fileName);
                            updateLogs(id, "Download");
                            insertCounter(id, "download");
                        } else if (type === "shared") {
                            setState({ ...state, url: res.data.fileUrl });
                        } else {
                            setVideoState(res.data.fileUrl);
                        }
                    }
                },
                (error) => {
                    //console.log('error', error)
                    Swal.fire({
                        icon: "error",
                        title: "Share or download fail",
                        text: "Error sharing/download file",
                    });
                }
            );
        }
    };

    const downloadFile = async (link, file_name) => {
        try {
            setIsLoading(true);
            const response = await fetch(link);
            if (!response.ok) throw new Error('Network response was not ok.');
            const blob = await response.blob();
            if (blob.size > 0) {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none; position: absolute; left: -9999px; top: -9999px;";
                a.href = url;
                a.download = file_name;
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Download failed",
                    text: `Failed to download file: Server responded with no content.`,
                });
            }
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Download failed",
                text: `Failed to download file: ${err}`,
            });
        } finally {
            setIsLoading(false)
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.textContent = text;

        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        var selection = document.getSelection();
        var range = document.createRange();

        range.selectNode(textArea);
        selection.removeAllRanges();
        selection.addRange(range);

        try {
            var successful = document.execCommand("copy");
            var msg = successful ? "successful" : "unsuccessful";
            Swal.fire({
                icon: "success",
                title: "Copy Link",
                text: "Copying link was" + msg,
            });
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Copy Link failed!",
                text: `Fallback: Oops, unable to copy: ,${err}`,
            });
        }
        selection.removeAllRanges();
        document.body.removeChild(textArea);
    };

    const copyTextToClipboard = (text) => async () => {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }

        await navigator.clipboard.writeText(text).then(
            () => {
                Swal.fire({
                    icon: "success",
                    title: "Copy Link",
                    text: "Copying link was successful",
                });
            },
            (err) => {
                Swal.fire({
                    icon: "error",
                    title: "Copy Link failed!",
                    text: `Could not copy Link: ,${err}`,
                });
            }
        );
    };

    const insertFavorite = () => {
        const body = {
            id: id,
            userid: userInfo.userid,
        };

        createFavorite(
            body,
            (res) => {
                if (res.status == 200 || res.status == 201) {
                    Swal.fire({
                        icon: "success",
                        title: "Add Asset into favorite success",
                        text: res.message,
                    }).then(updateLogs(id, "Favorite"), insertCounter(id, "favorite"));
                }
            },
            (error) => {
                Swal.fire({
                    icon: "error",
                    title: "Add Asset into favorite fail",
                    text: error.response.data.message,
                });
            }
        );
    };

    const insertCounter = (id, param) => {
        const body = { status: param };

        setCounter(
            id,
            body,
            (res) => {
                if (res.status == 200 || res.status == 201) {
                    console.log("counter", res.data.message);
                }
            },
            (error) => {
                console.log("counter_error", error.response.data.message);
            }
        );
    };

    useEffect(() => {
        getAssetById(id)
            .then((res) => {
                if (res.data.status === "Publish") {
                    getAssets({
                        page: 1,
                        perpage: 10,
                        order: `created_on`,
                        direction: `desc`,
                        filter: `is_active:true,status:Publish,type.type_name:${res.data.type.type_name}`,
                        select: `title,thumbnail,created_on`,
                    }).then((res1) => {
                        getUsers({ select: `avatar`, filter: `_id:${res.data.user._id}` }).then((res2) => {
                            setStates({ assets: res1.data.data, asset: res.data, username: res.data.user.fullname, avatar: res2.data.data[0].avatar });

                            if (res.data.type.type_name === "Video") {
                                setTimeout(() => {
                                    saveFile("video", 1800, "std", 0, res.data);
                                }, 1000);
                            }
                        });
                    });
                } else {
                    Swal.fire({
                        icon: "info",
                        title: "Asset Status",
                        text: "The asset can't be accessed, it's not published",
                    }).then(() => {
                        navigate(-1);
                    });
                }
            })
            .catch(
                ({
                    response: {
                        data: { message },
                    },
                }) => {
                    Swal.fire({
                        icon: "error",
                        title: "Error when getting asset",
                        text: message,
                    }).then(() => {
                        navigate(-1);
                    });
                }
            );

        updateLogs(id, "View");
        insertCounter(id, "view");
    }, [id]);

    const { assets, asset, processing, email, emails, isFocus, selectedLists, url, expires, username, avatar } = state;

    useEffect(() => {
        if (email != "") {
            const time = setTimeout(() => {
                getUserIdentity(email, ({ data }) => {
                    if (data.total > 0) {
                        setState({ ...state, emails: data.data });
                    } else {
                        setState({ ...state, isFocus: false });
                    }
                });
            }, 150);

            return () => clearTimeout(time);
        } else {
            setState({ ...state, emails: [], isFocus: false });
        }
    }, [email]);

    return (
        <>
            {isLoading ? (
                <div className="container wrap_detail">
                    <div className="d-flex mt-5" style={{ justifyContent: "center", alignItems: "center", width: "100%" }}>
                        <div className="spinner-border" role="status" />
                        <h2>&nbsp; Please Wait</h2>
                    </div>

                </div>
            ) : (
                <div className="container padding_wrap_detail">
                    <div onClick={onBack} className="button_back">
                        <span className="fa fa-chevron-left"></span> <span> Back </span>
                    </div>
                    {/* {JSON.stringify(state.asset)} */}
                    <div className="wrap_detail">
                        <div className="wrap_detail_grid">
                            {asset.type?.type_name == "Video" && videoState != "" && (
                                <div className="form-control_video">
                                    <video src={videoState} autoPlay={true} controls={true} className="style_video"></video>
                                </div>
                            )}
                            {asset.type?.type_name != "Video" && (
                                <div className="form-control grid_content">
                                    <img src={asset.thumbnail?.preview_url != undefined ? process.env.REACT_APP_OBS_URL + asset.thumbnail?.preview_url : no_image} alt="" />
                                </div>
                            )}
                            <div className="detail_uploaded">
                                <div className="detail_uploaded_detail">
                                    <div className="detail_uploaded_detail_title">{asset.title}</div>
                                    <div className="detail_uploaded_detail_date">{setDateFormat(asset.created_on)}</div>
                                </div>
                                <div className="wrap_avatar">
                                    <div>
                                        <img src={avatar != "" ? process.env.REACT_APP_OBS_URL + avatar : profile} alt="" className="img-circle elevation-2 wrap_avatar_img" />
                                    </div>
                                    <div className="wrap_img_name">{username}</div>
                                </div>
                            </div>
                        </div>
                        <div className="flex_1_column mt-30">
                            <div className="flex_end">
                                <button className="btn btn-secondary btn-lg button_save" type="button" onClick={() => insertFavorite()}>
                                    Save
                                </button>
                                <button className="btn btn-secondary btn-lg button_share" type="button" data-toggle="dropdown">
                                    Share
                                </button>
                                <div className="dropdown-menu w_200">
                                    <div className="shared_type">Shared Type</div>
                                    {asset.file?.std && !Array.isArray(asset.file.std) && (
                                        <a className="dropdown-item" href="#" onClick={() => showModal("std")}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>{truncate(asset.file.std?.original_name.split("_")[1], 10) || ""}</span>
                                                <span className="f_12">
                                                    {asset.file.std?.size || 0}
                                                    {asset.file.std?.unit || ""}
                                                </span>
                                            </div>
                                        </a>
                                    )}

                                    {asset.file?.std &&
                                        Array.isArray(asset.file.std) &&
                                        asset.file.std.map((item, i) => (
                                            <a key={"key" + i} className="dropdown-item" href="#" onClick={() => showModal("std", i)}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{truncate(item?.original_name.split("_")[1], 10) || ""}</span>
                                                    <span className="f_12">
                                                        {item?.size || 0}
                                                        {item?.unit || ""}
                                                    </span>
                                                </div>
                                            </a>
                                        ))}

                                    {asset.file?.high && !Array.isArray(asset.file.high) && (
                                        <a className="dropdown-item" href="#" onClick={() => showModal("high")}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>{truncate(asset.file.high?.original_name.split("_")[1], 10) || ""}</span>
                                                <span className="f_12">
                                                    (High) {asset.file.high?.size || 0}
                                                    {asset.file.high?.unit || ""}
                                                </span>
                                            </div>
                                        </a>
                                    )}

                                    {asset.file?.high &&
                                        Array.isArray(asset.file.high) &&
                                        asset.file.high.map((item, i) => (
                                            <a key={"key" + i} className="dropdown-item" href="#" onClick={() => showModal("high", i)}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{truncate(item.original_name.split("_")[1], 10) || ""}</span>
                                                    <span className="f_12">
                                                        (High) {item.size || 0}
                                                        {item.unit || ""}
                                                    </span>
                                                </div>
                                            </a>
                                        ))}

                                    {asset.file?.low && !Array.isArray(asset.file.low) && (
                                        <a className="dropdown-item" href="#" onClick={() => showModal("low")}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>{truncate(asset.file.low?.original_name.split("_")[1], 10) || ""}</span>
                                                <span className="f_12">
                                                    (Low) {asset.file.low?.size || 0}
                                                    {asset.file.low?.unit || ""}
                                                </span>
                                            </div>
                                        </a>
                                    )}

                                    {asset.file?.low &&
                                        Array.isArray(asset.file.low) &&
                                        asset.file.low.map((item, i) => (
                                            <a key={"key" + i} className="dropdown-item" href="#" onClick={() => showModal("low", i)}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{truncate(item?.original_name.split("_")[1], 10) || ""}</span>
                                                    <span className="f_12">
                                                        (Low) {item?.size || 0}
                                                        {item?.unit || ""}
                                                    </span>
                                                </div>
                                            </a>
                                        ))}

                                    {asset.file?.raw && !Array.isArray(asset.file.raw) && (
                                        <div>
                                            <div className="dropdown-divider" />
                                            <a className="dropdown-item" href="#" onClick={() => showModal("raw")}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{truncate(asset.file.raw?.original_name.split("_")[1], 10) || ""}</span>
                                                    <span className="f_12">
                                                        {asset.file.raw?.size || 0}
                                                        {asset.file.raw?.unit || ""}
                                                    </span>
                                                </div>
                                            </a>
                                        </div>
                                    )}

                                    {asset.file?.raw &&
                                        Array.isArray(asset.file.raw) &&
                                        asset.file.raw.map((item, i) => (
                                            <div key={"key" + i}>
                                                <div className="dropdown-divider" />
                                                <a key={"key" + i} className="dropdown-item" href="#" onClick={() => showModal("raw", i)}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span>{truncate(item?.original_name.split("_")[1], 10) || ""}</span>
                                                        <span className="f_12">
                                                            {item?.size || 0}
                                                            {item?.unit || ""}
                                                        </span>
                                                    </div>
                                                </a>
                                            </div>
                                        ))}
                                </div>
                            </div>
                            <div className="flex_end" style={{ marginTop: 16 }}>
                                <div className="">
                                    <button type="button" className="btn btn-success btn-lg d-flex justify-content-between align-items-center w_309 mt-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <div className="flex-grow-1">Download</div>
                                        <span className="fa fa-caret-down"></span>
                                    </button>
                                    <div className="dropdown-menu w_309">
                                        <div style={{ padding: 16, color: "#ccc" }}>File Type</div>
                                        {asset.file?.std && !Array.isArray(asset.file.std) && (
                                            <a className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "std")}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{truncate(asset.file.std?.original_name.split("_")[1], 22) || ""}</span>
                                                    <span className="f_12">
                                                        {asset.file.std?.size || 0}
                                                        {asset.file.std?.unit || ""}
                                                    </span>
                                                </div>
                                            </a>
                                        )}
                                        {asset.file?.std &&
                                            Array.isArray(asset.file.std) &&
                                            asset.file.std.map((item, i) => (
                                                <a key={"key" + i} className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "std", i)}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span>{truncate(item?.original_name.split("_")[1], 22) || ""}</span>
                                                        <span className="f_12">
                                                            {item?.size || 0}
                                                            {item?.unit || ""}
                                                        </span>
                                                    </div>
                                                </a>
                                            ))}
                                        {asset.file?.high && !Array.isArray(asset.file.high) && (
                                            <a className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "high")}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{truncate(asset.file.high?.original_name.split("_")[1], 22) || ""}</span>
                                                    <span className="f_12">
                                                        (High) {asset.file.high?.size || 0}
                                                        {asset.file.high?.unit || ""}
                                                    </span>
                                                </div>
                                            </a>
                                        )}
                                        {asset.file?.high &&
                                            Array.isArray(asset.file.high) &&
                                            asset.file.high.map((item, i) => (
                                                <a key={"key" + i} className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "high", i)}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span>{truncate(item?.original_name.split("_")[1], 22) || ""}</span>
                                                        <span className="f_12">
                                                            (High) {item?.size || 0}
                                                            {item?.unit || ""}
                                                        </span>
                                                    </div>
                                                </a>
                                            ))}
                                        {asset.file?.low && !Array.isArray(asset.file.low) && (
                                            <a className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "low")}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{truncate(asset.file.low?.original_name.split("_")[1], 22) || ""}</span>
                                                    <span className="f_12">
                                                        (Low) {asset.file.low?.size || 0}
                                                        {asset.file.low?.unit || ""}
                                                    </span>
                                                </div>
                                            </a>
                                        )}
                                        {asset.file?.low &&
                                            Array.isArray(asset.file.low) &&
                                            asset.file.low.map((item, i) => (
                                                <a key={"key" + i} className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "low", i)}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span>{truncate(item?.original_name.split("_")[1], 22) || ""}</span>
                                                        <span className="f_12">
                                                            (Low) {item?.size || 0}
                                                            {item?.unit || ""}
                                                        </span>
                                                    </div>
                                                </a>
                                            ))}
                                        {asset.file?.raw && !Array.isArray(asset.file.raw) && (
                                            <div>
                                                <div className="dropdown-divider" />
                                                <a className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "raw")}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span>{truncate(asset.file.raw?.original_name.split("_")[1], 22) || ""}</span>
                                                        <span className="f_12">
                                                            {asset.file.raw?.size || 0}
                                                            {asset.file.raw?.unit || ""}
                                                        </span>
                                                    </div>
                                                </a>
                                            </div>
                                        )}
                                        {asset.file?.raw &&
                                            Array.isArray(asset.file.raw) &&
                                            asset.file.raw.map((item, i) => (
                                                <div>
                                                    <div className="dropdown-divider" />
                                                    <a key={"key" + i} className="dropdown-item" href="#" onClick={() => saveFile("favorite", 3600, "raw", i)}>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span>{truncate(item?.original_name.split("_")[1], 22) || ""}</span>
                                                            <span className="f_12">
                                                                {item?.size || 0}
                                                                {item?.unit || ""}
                                                            </span>
                                                        </div>
                                                    </a>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="detail_description_detail">
                        <div className="">
                            <span class="detail_uploaded_detail_title">Description</span>
                            {parser(asset?.description || "")}
                        </div>
                    </div>
                    <div className="wrap_slider">
                        <div style={{}}>
                            <div className="title-wrap-2">
                                <span>You might also like</span>
                            </div>

                            <div className="cstm-carousel" style={{ marginTop: 20 }}>
                                <Carousel responsive={responsive} draggable={true} keyBoardControl={true} removeArrowOnDeviceType={["tablet", "mobile"]} transitionDuration={500} infinite>
                                    {assets?.map((item, i) => (
                                        <div key={"rec_" + i} className="wrap_slider_grid">
                                            <img src={item.thumbnail.preview_url != undefined ? process.env.REACT_APP_OBS_URL + item.thumbnail.preview_url : ""} />
                                            <div className="wrap-card-overlay-4" onClick={onAssetClick(item._id)}>
                                                <div style={{ position: "absolute", width: "100%", bottom: 20, left: 0 }}>
                                                    <div className="card-text-title-14 card-text-overflow-14">{item.title}</div>
                                                    <div className="card-text-title-10">{setDateFormat(item.created_on)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Carousel>
                            </div>
                        </div>
                    </div>

                    <Modal id={modalId} title="Share Asset URL" onClose={onCloseModal} onAction={onShareUrls} btnActionName="Send" btnActionDisabled={false}>
                        <Overlay display={processing} />
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="expired" style={{ marginTop: 0 }}>
                                    Shared time
                                </label>
                                <select id="menu_level" defaultValue={""} className="form-control" onChange={(e) => onChangeExpire(e)}>
                                    <option value="">-- Select shared time --</option>
                                    {expires.map((item, i) => (
                                        <option key={`expire-${i}`} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Employee email</label>
                                <input id="email" onChange={(e) => onChangeEmail(e)} className="form-control" type="email" value={email} autoComplete="off" />
                                {emails.length > 0 && isFocus && (
                                    <div className="mt-1 p-2" style={{ zIndex: 1, position: "absolute", background: "#fff", border: "1px solid #ccc", borderRadius: 5 }}>
                                        {emails.map((item, i) => (
                                            <div onClick={() => onSelectEmail(item)} key={i} className="d-flex align-items-center w-100 p-1 mb-1" style={{ border: "1px solid #ccc", borderRadius: 5, cursor: "pointer" }}>
                                                <span className="ml-2">{item.email}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email recipients</label>
                                <table className="table x-table-grey">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedLists?.map((item, i) => (
                                            <tr key={i.toString()}>
                                                <td>{item.name}</td>
                                                <td>{item.email}</td>
                                                <td>
                                                    <i className="fas fa-trash" onClick={() => removeEmailList(item.email)}></i>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <label htmlFor="email">Direct Copy Link</label>
                                    <div className="col-md-10">
                                        <input id="url" className="form-control" type="text" defaultValue={url} autoComplete="off" readOnly={true} />
                                    </div>
                                    <div className="col-md-2">
                                        <button type="button" className="btn btn-info" onClick={copyTextToClipboard(url)} disabled={url == "" ? true : false}>
                                            Copy
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            )}
        </>

    );
};

export default AssetDetailPage;